// @flow

import { reduce } from '../../network/reduce';
import type {
  ReconciliationStore,
} from '../../types/shoppingCenterType';

export type initialStateType = {
  +selectedStore: ?ReconciliationStore,
}

const initialState: initialStateType = {
  selectedStore: null,
  isCurrencyBySurface: true,
};

export const SAVE_SELECTED_STORE = 'SAVE_SELECTED_STORE';
export const IS_CURRENCY_BY_SURFACE = 'IS_CURRENCY_BY_SURFACE';

const storeReducer = reduce(initialState, {
  [SAVE_SELECTED_STORE]: 'selectedStore',
  [IS_CURRENCY_BY_SURFACE]: 'isCurrencyBySurface',
});

export default storeReducer;
